import request from '@/utils/changanRequest'

// 查询警情发布列表
export function listAlert(query) {
  return request({
    url: '/system/policeAlert/list',
    method: 'get',
    params: query
  })
}

// 查询警情发布详细
export function getAlert(id) {
  return request({
    url: '/system/policeAlert/' + id,
    method: 'get'
  })
}

// 新增警情发布
export function addAlert(data) {
  return request({
    url: '/system/policeAlert',
    method: 'post',
    data: data
  })
}

// 修改警情发布
export function updateAlert(data) {
  return request({
    url: '/system/policeAlert',
    method: 'put',
    data: data
  })
}

// 删除警情发布
export function delAlert(id) {
  return request({
    url: '/system/policeAlert/' + id,
    method: 'delete'
  })
}
